import { render, staticRenderFns } from "./EditPaket.vue?vue&type=template&id=34cb522d&scoped=true"
import script from "./EditPaket.vue?vue&type=script&lang=js"
export * from "./EditPaket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cb522d",
  null
  
)

export default component.exports